const STAGE = process.env.stage || 'prod';

let BASE_URL = 'http://localhost:3000/prod';
let ENV_MODE = STAGE;

if (STAGE === 'dev') {
  BASE_URL = 'https://dev.myalice-api.com';
  ENV_MODE = 'dev';
}
if (STAGE === 'prod') {
  BASE_URL = 'https://prod.myalice-api.com';
}

const USER_POOL_ID = 'us-east-1_DhtPwg46h';
const CLIENT_ID = '4eglgo9mbht91hr5nnmu29mrp7';
const IDENTITY_POOL_ID = 'us-east-1:59c17aa1-c7b9-41ad-a3c5-89f375874fa3';
const REGION = 'us-east-1';
const ALICE_API = 'alice';
const VISIBLE_VERSION = 'v5.0.0';
const BUCKET_NAME = 'alice-app-images';

export default {
  EMAIL_SOURCE: 'support@myalice.com',
  IMAGE_URL: 'https://alice-app-images.s3.amazonaws.com/',
  REGION,
  BASE_URL,
  ALICE_API,
  USER_POOL_ID,
  CLIENT_ID,
  IDENTITY_POOL_ID,
  VISIBLE_VERSION,
  ENV_MODE,
  BUCKET_NAME,
  STAGE,
};
